import { Component } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, NotificationServer } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-server-grid',
    templateUrl: './notification-server-grid.component.html',
    styleUrls: ['./notification-server-grid.component.scss']
})
export class NotificationServerGridComponent extends BaseGridComponent<NotificationServer, BaseState> {

    constructor(A: ServiceBagService) {
        super(A, 'NotificationServerGridComponent', NotificationServer, BaseState);
    }

    OnNavigate(e: any) {
        this.Navigate(['/pages/general/notification-server', e.data.EntryID]);
    }
}
